import { Component, Input, } from '@angular/core';
import SlotSecondPageModel from '../../models/slot-second-page.model';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { SummaryPricesService } from '../../customer-offer/summary/summary-prices.service';

@Component({
  selector: '[side-order-details-slot]',
  templateUrl: './side-order-details-slot.component.html',
})
export class SideOrderDetailsSlotComponent {
  @Input() public slot: SlotSecondPageModel;
  public isRetentionBeforeEOP = false;

  constructor(
    public commonInfo: CommonInfoService,
    private summaryPricesService: SummaryPricesService
  ) {}

  ngOnInit(): void {
    this.isRetentionBeforeEOP = this.summaryPricesService.isRetentionBeforeEOP;
  }
}
